import { render, staticRenderFns } from "./productform.vue?vue&type=template&id=b535de00&scoped=true&"
import script from "./productform.vue?vue&type=script&lang=js&"
export * from "./productform.vue?vue&type=script&lang=js&"
import style0 from "./productform.vue?vue&type=style&index=0&id=b535de00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b535de00",
  null
  
)

export default component.exports